import IconComponent from "icons/IconComponent";

import EditIcon from "./edit.svg";

export default (EditIcon as any) as IconComponent;
